import React from 'react';

const TimeZoneContext = React.createContext();
export default TimeZoneContext;
